const version = APP_VERSION;
const versionString = `v${version}`;
const versionElement = document.getElementById('version');
if (versionElement) {
  versionElement.textContent = versionString;
}

console.log(`App Version: ${versionString}`);